// tslint:disable: variable-name

export class CallBackModel {
  ResponseString: string;
  QueryString: string;
  Headers: {[key: string]: string};

  constructor(responseString: string, queryString: string, headers: {[key: string]: string} = {}) {
    this.ResponseString = responseString;
    this.QueryString = queryString;
    this.Headers = headers;
  }
}
